import React, { useState } from "react";
import CustomButton from "../CustomButton";
import CustomSelect from "../CustomSelect";
import ModalLayout from "../layouts/ModalLayout";
import { toast } from "sonner";
import attendanceApis from "../../api/attendanceApis";
import { useBranchCode } from "../../util/hooks/useBranch";
import ClassSelect from "../common-input/ClassSelect";

interface Props {
  onClose?: () => void;
  onSuccess?: () => void;
}

function AttendanceReportYearly({ onClose, onSuccess }: Props) {
  const [academicYear, setAcademicYear] = useState("");
  const [selectedClassId, setSelectedClassId] = useState<number | "">("");
  const [loading, setLoading] = useState(false);

  const branchCode = useBranchCode();

  const handleDownload = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!academicYear) return toast.error("Please select an academic year");
    if (!selectedClassId) return toast.error("Please select a class");

    setLoading(true);
    await attendanceApis.getStudentYearlyReport(
      branchCode,
      academicYear.split("-")[0],
      Number(selectedClassId),
    );

    setLoading(false);
    if (onSuccess) onSuccess();
    if (onClose) onClose();
  };

  return (
    <ModalLayout onClose={onClose}>
      <form className="flex flex-col gap-8 max-w-xl" onSubmit={handleDownload}>
        <h3 className="text-xl font-semibold text-neutral-400">
          Download Attendance Report
        </h3>

        <CustomSelect
          name="academicYear"
          label="Academic Year"
          value={academicYear}
          options={["2026-27", "2027-28", "2028-29"]}
          placeholder="Select academic Year"
          onChange={(e) => setAcademicYear(e.target.value)}
        />

        <ClassSelect
          name="classId"
          label="Class"
          value={selectedClassId}
          placeholder="Select Class"
          onChange={(e) => {
            const val = e.target.value;
            setSelectedClassId(val === "" ? "" : Number(val));
          }}
        />

        <div className="flex justify-end gap-5">
          <CustomButton
            color="bg-neutral-200"
            text="Cancel"
            onClick={onClose}
          />
          <CustomButton
            color="bg-success-600"
            text={loading ? "Downloading..." : "Download"}
            type="submit"
            disabled={loading}
          />
        </div>
      </form>
    </ModalLayout>
  );
}

export default AttendanceReportYearly;
